import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8a82a3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "me-4" }
const _hoisted_4 = { class: "card-header border-0 pt-4" }
const _hoisted_5 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_6 = {
  type: "button",
  class: "btn btn-light-success"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0 compact-table" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "svg-icon svg-icon-3" }
const _hoisted_11 = { class: "badge badge-light-info" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-light"
}
const _hoisted_18 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_19 = { class: "text-muted fs-7" }
const _hoisted_20 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_21 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = { class: "modal-title" }
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = { class: "mb-7" }
const _hoisted_27 = { class: "fw-bold mb-3" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-4 mb-3" }
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = { class: "col-md-4 mb-3" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = { class: "badge badge-light-info" }
const _hoisted_34 = { class: "col-md-4 mb-3" }
const _hoisted_35 = { class: "text-muted" }
const _hoisted_36 = { class: "col-md-4 mb-3" }
const _hoisted_37 = { class: "text-muted" }
const _hoisted_38 = { class: "col-md-8 mb-3" }
const _hoisted_39 = { class: "text-muted" }
const _hoisted_40 = { class: "mb-7" }
const _hoisted_41 = { class: "fw-bold mb-3" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-3 mb-3" }
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = { class: "col-md-3 mb-3" }
const _hoisted_46 = { class: "text-muted" }
const _hoisted_47 = { class: "col-md-3 mb-3" }
const _hoisted_48 = { class: "text-muted" }
const _hoisted_49 = { class: "col-md-3 mb-3" }
const _hoisted_50 = { class: "text-muted" }
const _hoisted_51 = { class: "col-md-3 mb-3" }
const _hoisted_52 = { class: "text-muted" }
const _hoisted_53 = {
  key: 0,
  class: "mb-7"
}
const _hoisted_54 = { class: "fw-bold mb-3" }
const _hoisted_55 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_56 = {
  key: 1,
  class: "mb-7"
}
const _hoisted_57 = { class: "fw-bold mb-3" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "mb-2" }
const _hoisted_61 = { class: "text-muted fw-bold" }
const _hoisted_62 = {
  key: 0,
  class: "bg-light p-3 rounded"
}
const _hoisted_63 = {
  key: 1,
  class: "bg-light p-3 rounded text-muted"
}
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "mb-2" }
const _hoisted_66 = { class: "text-muted fw-bold" }
const _hoisted_67 = {
  key: 0,
  class: "bg-light p-3 rounded"
}
const _hoisted_68 = {
  key: 1,
  class: "bg-light p-3 rounded text-muted"
}
const _hoisted_69 = {
  key: 2,
  class: "mb-7"
}
const _hoisted_70 = { class: "fw-bold mb-3" }
const _hoisted_71 = { class: "bg-light p-3 rounded" }
const _hoisted_72 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuditLogsAdvancedSearch = _resolveComponent("AuditLogsAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'audit'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_AuditLogsAdvancedSearch, {
                onTypeSelected: _ctx.onTypeChange,
                onReset: _ctx.onReset
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.showExportBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_vue3_json_excel, {
                    "json-data": _ctx.tableData,
                    fields: _ctx.excelHeader,
                    worksheet: "Audit Logs",
                    name: _ctx.exportFileName
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr078.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["json-data", "fields", "name"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              loading: _ctx.loading,
              "rows-per-page": 10,
              total: _ctx.totalItems,
              "enable-items-per-page-dropdown": false,
              onCurrentChange: _ctx.pageChanged
            }, {
              "cell-actions": _withCtx(({ row: log }) => [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.viewDetails(log)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                  ])
                ], 8, _hoisted_9)
              ]),
              "cell-id": _withCtx(({ row: log }) => [
                _createTextVNode(_toDisplayString(log.id), 1)
              ]),
              "cell-entityType": _withCtx(({ row: log }) => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatEntityType(log.entityType)), 1)
              ]),
              "cell-entityId": _withCtx(({ row: log }) => [
                _createTextVNode(_toDisplayString(log.entityId), 1)
              ]),
              "cell-action": _withCtx(({ row: log }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'badge-light-success': log.action === 'CREATE',
              'badge-light-primary': log.action === 'UPDATE',
              'badge-light-danger': log.action === 'DELETE',
            }])
                }, _toDisplayString(_ctx.translate(log.action.toLowerCase())), 3)
              ]),
              "cell-user": _withCtx(({ row: log }) => [
                (log.userName || log.userEmail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: "fw-bold text-truncate",
                        style: {"max-width":"150px"},
                        title: log.userName
                      }, _toDisplayString(log.userName || _ctx.translate('unknown')), 9, _hoisted_13),
                      _createElementVNode("div", {
                        class: "text-muted fs-7 text-truncate",
                        style: {"max-width":"150px"},
                        title: log.userEmail
                      }, _toDisplayString(log.userEmail), 9, _hoisted_14)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('system')), 1))
              ]),
              "cell-changedFields": _withCtx(({ row: log }) => [
                (log.changedFields && log.changedFields.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.changedFields.slice(0, 2), (field, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "badge badge-light me-1 mb-1"
                        }, _toDisplayString(field), 1))
                      }), 128)),
                      (log.changedFields.length > 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, " +" + _toDisplayString(log.changedFields.length - 2), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
              ]),
              "cell-createdAt": _withCtx(({ row: log }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(log.createdAt)), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatTime(log.createdAt)), 1)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedLog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.translate('auditLogDetails')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDetails && _ctx.closeDetails(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h6", _hoisted_27, _toDisplayString(_ctx.translate('basicInformation')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.translate('ID')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.id), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('entityType')), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatEntityType(_ctx.selectedLog.entityType)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('entityId')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.entityId), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('action')), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", {
                      'badge-light-success': _ctx.selectedLog.action === 'CREATE',
                      'badge-light-primary': _ctx.selectedLog.action === 'UPDATE',
                      'badge-light-danger': _ctx.selectedLog.action === 'DELETE',
                    }])
                        }, _toDisplayString(_ctx.translate(_ctx.selectedLog.action.toLowerCase())), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('timestamp')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.selectedLog.createdAt)) + " " + _toDisplayString(_ctx.formatTime(_ctx.selectedLog.createdAt)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("h6", _hoisted_41, _toDisplayString(_ctx.translate('userInformation')), 1),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate('userName')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.userName || _ctx.translate('unknown')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('userEmail')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.userEmail || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('userId')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.userId || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.translate('ipAddress')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.ipAddress || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.translate('userAgent')), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.selectedLog.userAgent || '-'), 1)
                    ])
                  ])
                ]),
                (
              _ctx.selectedLog.changedFields && _ctx.selectedLog.changedFields.length > 0
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("h6", _hoisted_54, _toDisplayString(_ctx.translate('changedFields')), 1),
                      _createElementVNode("div", _hoisted_55, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedLog.changedFields, (field, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "badge badge-light-primary"
                          }, _toDisplayString(field), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedLog.oldValues || _ctx.selectedLog.newValues)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("h6", _hoisted_57, _toDisplayString(_ctx.translate('valueComparison')), 1),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.translate('oldValues')), 1)
                          ]),
                          (_ctx.selectedLog.oldValues)
                            ? (_openBlock(), _createElementBlock("pre", _hoisted_62, _toDisplayString(JSON.stringify(_ctx.selectedLog.oldValues, null, 2)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_63, "-"))
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.translate('newValues')), 1)
                          ]),
                          (_ctx.selectedLog.newValues)
                            ? (_openBlock(), _createElementBlock("pre", _hoisted_67, _toDisplayString(JSON.stringify(_ctx.selectedLog.newValues, null, 2)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_68, "-"))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedLog.metadata)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _createElementVNode("h6", _hoisted_70, _toDisplayString(_ctx.translate('metadata')), 1),
                      _createElementVNode("pre", _hoisted_71, _toDisplayString(JSON.stringify(_ctx.selectedLog.metadata, null, 2)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDetails && _ctx.closeDetails(...args)))
                }, _toDisplayString(_ctx.translate('close')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}